import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Comprehensive ResizeObserver error suppression
const suppressResizeObserver = () => {
  // Suppress from window.onerror
  const originalOnError = window.onerror;
  window.onerror = (message, ...args) => {
    if (message && typeof message === 'string' && message.includes('ResizeObserver')) {
      return true;
    }
    return originalOnError ? originalOnError(message, ...args) : false;
  };

  // Suppress from error events
  window.addEventListener('error', (e) => {
    if (e.message && e.message.includes('ResizeObserver')) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return true;
    }
  }, true);

  // Suppress from unhandled rejections
  window.addEventListener('unhandledrejection', (e) => {
    if (e.reason && e.reason.message && e.reason.message.includes('ResizeObserver')) {
      e.preventDefault();
      return true;
    }
  });

  // Patch ResizeObserver to catch errors
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        requestAnimationFrame(() => {
          try {
            callback(entries, observer);
          } catch (e) {
            // Silently ignore ResizeObserver errors
          }
        });
      });
    }
  };
};

suppressResizeObserver();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
